import 'owl.carousel';

export default function home() {
	$( '#home-carousel .owl-carousel' ).owlCarousel( {
		items: 1,
		loop: true,
		dots: false,
		nav: true,
		navText: ['<span class="sr-only">Prev</span>', '<span class="sr-only">Next</span>']
	} );

	$( '#home-news .owl-carousel' ).owlCarousel( {
		items: 2,
		loop: true,
		dots: false,
		nav: true,
		margin: 100,
		navText: ['<span class="sr-only">Prev</span>', '<span class="sr-only">Next</span>'],
		responsive: {
			0: {
				items: 1,
				margin: 0
			},
			768: {
				items: 2,
				margin: 50
			},
			992: {
				items: 2,
				margin: 100
			}
		}
	} );

	$( '#home-videos .owl-carousel' ).owlCarousel( {
		items: 3,
		loop: true,
		dots: false,
		nav: true,
		margin: 25,
		navText: ['<span class="sr-only">Prev</span>', '<span class="sr-only">Next</span>'],
		responsive: {
			0: {
				items: 1,
				margin: 0
			},
			768: {
				items: 2,
				margin: 60
			},
			992: {
				items: 3,
				margin: 25
			}
		}
	} );

	$( '#video-carousel-wrap a' ).on( 'click', function ( e ) {
		e.preventDefault();
		const yt_id = $( this ).attr( 'data-yt-id' );
		const title = $( this ).find( '.video-title' ).html();

		$( '#video-player iframe' ).attr( 'src', 'https://www.youtube.com/embed/' + yt_id + '?autoplay=1' );
		$( '#video-player .video-title' ).html( title );
	} );

	$( '#home-music .owl-carousel' ).owlCarousel( {
		items: 3,
		loop: true,
		dots: false,
		nav: true,
		margin: 60,
		navText: ['<span class="sr-only">Prev</span>', '<span class="sr-only">Next</span>'],
		responsive: {
			0: {
				items: 1,
				margin: 0
			},
			768: {
				items: 2,
				margin: 60
			},
			992: {
				items: 3,
				margin: 60
			}
		}
	} );

	if ( $( 'body' ).hasClass( 'sme-loading' ) ) {
		const video = $( '#sme-loader>video' );
		video.on( 'ended', function () {
			$( 'body' ).removeClass( 'sme-loading' );
			$( '#sme-loader' ).fadeOut();
		} );
	}
}